// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"1eace3cb","636":"2abbafbf"}[chunkId] + ".chunk.js";
};